import quickFetch from 'quick-fetch';
import { getSuperStoreValue } from './utils/superStoreUtils';
(function () {
  quickFetch.afterAuth(authData => {
    var _authData$user, _authData$portal;
    const scopes = (authData === null || authData === void 0 || (_authData$user = authData.user) === null || _authData$user === void 0 ? void 0 : _authData$user.scopes) || [];
    const isUngatedForCopilotV2 = authData === null || authData === void 0 || (_authData$portal = authData.portal) === null || _authData$portal === void 0 ? void 0 : _authData$portal.enabled_v3_gates.includes('Copilot:V2');
    // Only make initial requests if the user has the chatspot-access scope
    if (scopes.includes('chatspot-access')) {
      quickFetch.makeEarlyRequest('chatspotAuth', {
        url: quickFetch.getApiUrl('/chatspot-high-volume/v1/user/info'),
        dataType: 'json',
        contentType: 'application/json',
        type: 'GET',
        data: JSON.stringify({
          early: true
        })
      });

      /**
       * Handle getLatestOrCreateNew thread request
       * Logic is copied from both App.tsx and ThreadsInit.tsx
       */
      let entry = '';
      try {
        entry = localStorage['Copilot:Settings:copilot-last-open'];
        if (entry === undefined) {
          return entry;
        }
        entry = JSON.parse(entry);
      } catch (error) {
        entry = '';
      }
      const latestUserActivityAt = parseInt(entry, 10) || Date.now();

      // Disable our V2 early request for now. We aren't using it and always making a follow-up request anyway.
      if (!isUngatedForCopilotV2) {
        // Copilot V1: getLatestOrCreateNew
        let threadIdToUse = undefined;
        try {
          let topWindow = window;
          while (topWindow.parent !== topWindow) {
            topWindow = topWindow.parent;
          }
          // represents the host app's query params derived from its URL
          const parentQueryParams = new URLSearchParams(topWindow.location.search);
          const copilotThreadId = parentQueryParams.get('copilotThreadId') || '';
          threadIdToUse = parseInt(copilotThreadId, 10) || '';
        } catch (e) {
          threadIdToUse = '';
        }
        if (threadIdToUse) {
          var _threadIdToUse;
          const threadId = ((_threadIdToUse = threadIdToUse) === null || _threadIdToUse === void 0 ? void 0 : _threadIdToUse.toString()) || '';
          const timeZoneOffset = new Date().getTimezoneOffset();
          const latestActivityTimestamp = latestUserActivityAt;
          const messagesLimit = 5;
          quickFetch.makeEarlyRequest('getLatestOrCreateNew', {
            url: quickFetch.getApiUrl(`/chatspot-high-volume/v1/threads/latest-or-new/?threadId=${threadId}&timeZoneOffset=${timeZoneOffset}&latestActivityTimestamp=${latestActivityTimestamp}&messagesLimit=${messagesLimit}`),
            contentType: 'application/json',
            dataType: 'json',
            type: 'GET'
          });
        }
        // no query param ID => try superstore
        else {
          getSuperStoreValue('copilot-thread-id').then(superstoreThreadId => {
            let variant = 'nav';
            try {
              const iframeQueryParams = new URLSearchParams(window.location.search);
              const variantQueryParam = iframeQueryParams.get('variant');
              if (variantQueryParam) {
                variant = variantQueryParam;
              }
            } catch (e) {
              // Just swallow the error here if something happens, we can start without
              // it
            }
            const threadId = variant === 'nav' ? superstoreThreadId === null || superstoreThreadId === void 0 ? void 0 : superstoreThreadId.toString() : '';
            const timeZoneOffset = new Date().getTimezoneOffset();
            const latestActivityTimestamp = latestUserActivityAt;
            const messagesLimit = 5;
            quickFetch.makeEarlyRequest('getLatestOrCreateNew', {
              url: quickFetch.getApiUrl(`/chatspot-high-volume/v1/threads/latest-or-new/?threadId=${threadId}&timeZoneOffset=${timeZoneOffset}&latestActivityTimestamp=${latestActivityTimestamp}&messagesLimit=${messagesLimit}`),
              contentType: 'application/json',
              dataType: 'json',
              type: 'GET'
            });
          }).catch(e => {
            console.error('Failed to get thread ID from superstore:', e);
          });
        }
      }
    }
  });
})();